const ADD_CUSTOMER_PAYMENT = "ADD_CUSTOMER_PAYMENT";

export { ADD_CUSTOMER_PAYMENT };
